import { useBoundStore } from 'app/store';

export const radioStatusesSelector = ({
  isLatestLoaded,
  isTop8Loaded,
  isRubricsLoaded,
  isRadioRubricLoaded,
}) => ({
  isLatestLoaded,
  isTop8Loaded,
  isRubricsLoaded,
  isRadioRubricLoaded,
});

export const useRadioStatusesBoundStore = () => useBoundStore(radioStatusesSelector);
